import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';


class DeviceFilterMenu extends Component {
  state = {};

  renderMenuOptions() {
    return this.props.options.map((option) => {
      return (
        <MenuItem key={option.id} onClick={null}>
          <FormControlLabel
           control={
             <Checkbox
               checked={option.visible}
               onChange={() => this.props.onChange(option.id, !option.visible)}
               sx={{
                '&.Mui-checked': {
                  color: '#4a8bcc',
                },
               }}
             />
           }
           label={option.name}
          />
        </MenuItem>
      );
    });
  }

  render() {
    const { open, anchorEl } = this.props;

    return (
      <Menu
       id="mapDeviceFilterMenu"
       anchorEl={anchorEl}
       keepMounted
       open={open}
       onClose={this.props.onClose}
     >
      {this.renderMenuOptions()}
     </Menu>
    );
  }
}

DeviceFilterMenu.propTypes = {
  options: PropTypes.array.isRequired,
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
};

export default DeviceFilterMenu;
